var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrangeLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fi_9312240"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.2891 13.1719H5.32031C4.67297 13.1719 4.14844 12.6473 4.14844 12C4.14844 11.3527 4.67297 10.8281 5.32031 10.8281H19.2891C19.9364 10.8281 20.4609 11.3527 20.4609 12C20.4609 12.6473 19.9364 13.1719 19.2891 13.1719Z",
    fill: "#FF5B00"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.6871 18.7148C10.4021 18.7148 10.1161 18.6112 9.89066 18.4022L3.91409 12.8592C3.67315 12.6356 3.53675 12.3211 3.53909 11.992C3.54144 11.6634 3.68159 11.3503 3.92581 11.13L10.0664 5.58702C10.5469 5.15343 11.288 5.1914 11.7216 5.67187C12.1552 6.15234 12.1172 6.89343 11.6367 7.32702L6.44675 12.0117L11.4844 16.6837C11.9588 17.1239 11.9869 17.8655 11.5467 18.3398C11.3157 18.5887 11.0021 18.7148 10.6871 18.7148Z",
    fill: "#FF5B00"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangeLeftArrow);
export default __webpack_public_path__ + "static/media/orange-left-arrow.838781242e2cfe3d40057bcf6d03eb13.svg";
export { ForwardRef as ReactComponent };